export default __webpack_public_path__ + "static/media/carrosel01.36ff6cfc.png";